import React, { useState, useEffect } from "react";
import { $host } from "../../../../../http";
import "../UserModal.css";  // Подключаем общие стили

const CreateSubscribe = ({ user, course, onClose, onSubscriptionCreated }) => {
    const [months, setMonths] = useState(1);
    const [loading, setLoading] = useState(false);
    const [courseOptions, setCourseOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {
        fetchCourseOptions();
    }, []);

    const fetchCourseOptions = async () => {
        try {
            const { data } = await $host.get("/api/public/course-options");
            setCourseOptions(data);
        } catch (error) {
            console.error("Ошибка загрузки опций курса:", error);
        }
    };

    const handleAssign = async () => {
        setLoading(true);
        try {
            const response = await $host.post("/api/admin/courses/give", {
                student_id: user.id,
                course_id: course.id,
                months: months,
                option_ids: selectedOptions,
            });

            console.log("Ответ сервера при создании подписки:", response); // Логируем для проверки

            if (!response || !response.data || !response.data.id) {
                throw new Error("Ошибка: сервер не вернул ID подписки.");
            }

            alert("Курс успешно назначен!");
            onSubscriptionCreated(response.data.id); // Передаём только ID подписки
            onClose();
        } catch (error) {
            console.error("Ошибка при назначении курса:", error);
            alert("Не удалось назначить курс.");
        } finally {
            setLoading(false);
        }
    };



    const handleOptionToggle = (optionId) => {
        setSelectedOptions((prev) =>
            prev.includes(optionId) ? prev.filter((id) => id !== optionId) : [...prev, optionId]
        );
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>✖</button>
                <h3 className="modal-header">Назначение курса</h3>
                <p className="course-title"><strong>Курс:</strong> {course.title}</p>

                <div className="modal-section">
                    <label className="modal-label">Продолжительность подписки (месяцы):</label>
                    <input
                        type="number"
                        min="1"
                        value={months}
                        onChange={(e) => setMonths(e.target.value)}
                        className="modal-input"
                    />
                </div>

                <div className="modal-section">
                    <label className="modal-label">Дополнительные опции:</label>
                    {courseOptions.length > 0 ? (
                        <div>
                            {courseOptions.map((option) => (
                                <label key={option.id} className="option-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={selectedOptions.includes(option.id)}
                                        onChange={() => handleOptionToggle(option.id)}
                                    />
                                    {option.description} ({option.price} руб.)
                                </label>
                            ))}
                        </div>
                    ) : (
                        <p style={{ color: "#777", fontSize: "14px" }}>Нет доступных опций</p>
                    )}
                </div>

                <div className="modal-footer">
                    <button className="modal-button modal-primary" onClick={handleAssign} disabled={loading}>
                        {loading ? "Назначение..." : "Назначить"}
                    </button>
                    <button className="modal-button modal-danger" onClick={onClose}>Отмена</button>
                </div>
            </div>
        </div>
    );
};

export default CreateSubscribe;
